<ion-content class="update-content">
  <div class="update-container">

    <!-- Icon -->
    <div class="update-icon-wrap">
      <div class="update-icon-circle">
        <ion-icon name="arrow-up-circle" class="update-icon"></ion-icon>
      </div>
    </div>

    <!-- Headline -->
    <h1 class="update-title">Update required</h1>
    <p class="update-subtitle">
      {{ versionInfo?.message || 'A new version of Bitbridge Billing is available. Please update to continue using the app.' }}
    </p>

    <!-- Version badge -->
    <div class="version-badge" *ngIf="versionInfo?.latestVersion">
      <span>Version {{ versionInfo.latestVersion }} is now available</span>
    </div>

    <!-- CTA -->
    <ion-button
      expand="block"
      class="update-btn"
      (click)="openStore()"
      size="large">
      <ion-icon slot="start" name="download-outline"></ion-icon>
      Update now
    </ion-button>

    <!-- Platform hint -->
    <p class="platform-hint">
      {{ platform === 'ios' ? 'Opens the App Store' : 'Opens Google Play' }}
    </p>

  </div>
</ion-content>
